class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.keywords = this.querySelector('[data-search-marquee="slides"]');
    this.speed = 3000;
    this.isKeywords = this.keywords?.children?.length;

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
    
    if (this.isKeywords) {
      this.input.form.addEventListener('submit', this.onFormSubmited.bind(this));
      this.input.addEventListener('focus', this.onInputFocus.bind(this));
      this.input.addEventListener('blur', this.onInputBlur.bind(this));
      this.start();
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }

  onFormSubmited() {
    const current = this.keywords?.querySelector('[aria-checked="true"]');
    if (!this.input.value && current?.textContent) {
      this.input.value = current.textContent.trim();
    }
  }

  onInputFocus() {
    const current = this.keywords?.querySelector('[aria-checked="true"]');
    if (current?.textContent) {
      this.input.placeholder = current.textContent;
    }
    this.stop();
  }

  onInputBlur() {
    this.start();
  }

  start() {
    if (!this.isKeywords) return;
    if (this.input.value) return;
    this.stop();
    this.timer = setInterval(() => {
      const current = this.keywords.querySelector('[aria-checked="true"]');
      const next = current.nextElementSibling;
      next.setAttribute('aria-checked', true);
      current.removeAttribute('aria-checked');
      current.style.marginTop = `-${current.offsetHeight}px`;

      setTimeout(() => {
        current.style.marginTop = ``;
        this.keywords.appendChild(current);
      }, 500);
    }, this.speed);
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}

customElements.define('search-form', SearchForm);